import { useContext, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import TagManager from "react-gtm-module";
import { SocketContext } from "../context/socket";
import {
  setCurrentPage,
  setRoomCode,
} from "../store/slices/MainScreenSlice";
import { setSyncHasProganda } from "../store/slices/UserSlice";
import { RootState } from "../store/store";
import { trackEvent } from "../services/appsflyer";
import { useSyncGameMutation } from "../store/Apis/UserApi";

export function useLandingAuth() {
  const user = useSelector((state: RootState) => state.user.user);
  const familyFriendly = useSelector(
    (state: RootState) => state.user.familyFriendly,
  );
  const hasPropaganda = useSelector(
    (state: RootState) => state.user.hasPropaganda,
  );
  const authenticated = useSelector(
    (state: RootState) => state.user.authenticated,
  );
  const socket = useContext(SocketContext);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [syncGame] = useSyncGameMutation();

  useEffect(() => {
    if (!hasPropaganda && user?.email) {
      //call api to check and sync
      syncGame({ email: user?.email }).unwrap().then((data) => {
        if (data?.success && data?.data?.platform !== "web" && data?.data?.game) {
          trackEvent("premium_activated", { 'origin_platform': data?.data?.platform, 'premium_origin_platform': data?.data?.platform })
          dispatch(setSyncHasProganda(data?.data))
        }
      }).catch((error) => {
        console.log(error.toString())
      })
    }
  }, [hasPropaganda, dispatch, syncGame, user?.email])

  useEffect(() => {
    if (socket) {
      socket.off("created");
      socket.off("ERROR");
      socket.on("created", (data) => {
        trackEvent("lobby_created", { 'platform': 'web', 'player_capacity': 8 });
        dispatch(setRoomCode(data));
        dispatch(setCurrentPage("logos"));
        navigate("/game");
      });
      socket.on("ERROR", (data) => {
        if (data?.type === "payment_required") {
          navigate("/purshase", { replace: true });
          return;
        }
        console.log("ERROR", data);
      });
    }
  }, [socket, dispatch, navigate]);

  const createRoom = () => {
    /*const freeTrialUsed = localStorage.getItem(FREE_TRIAL_USED_KEY) === "1";
    if (!hasPropaganda && freeTrialUsed) {
      navigate("/purshase", { replace: true });
      return;
    }*/
    socket?.emit("createLobby", { email: user?.email, familyFriendly });
  };

  const purchase = (source?: string) => {
    trackEvent("paywall_viewed", { source })
    navigate("/purshase");
  };

  const signin = () => {
    TagManager.dataLayer({ dataLayer: { event: "sign_up_click" } });
    navigate("/register");
  };

  return {
    authenticated,
    hasPropaganda,
    user,
    familyFriendly,
    createRoom,
    purchase,
    signin,
    navigate,
  };
}
